import React, { useMemo } from 'react';
import SignUp01 from './SignUp01';
import SignUp02 from './SignUp02';
import { FormProvider } from 'react-hook-form';
import useSignUp from '../../services/authentication/hooks/useSignUp';

/* eslint-disable no-unused-vars */
export interface SignUpPageProps {
  // formData: SignUpFormData;
  // // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  next: () => void;
  previous?: () => void;
  skip?: () => void;
}

const SignUp: React.FC = () => {
  const { currentStep, formHandler, handleStepChange, handleSubmission } =
    useSignUp();

  const formSteps = useMemo(
    () => [
      <SignUp01 next={() => handleStepChange(2)} />,
      <SignUp02 next={handleSubmission} previous={() => handleStepChange(1)} />,
      // <SignUp03 next={handleSubmission} />,
      // <SignUp04 next={() => false} previous={() => handleStepChange(3)} />,
    ],
    []
  );

  const content =
    currentStep <= 2 ? (
      <FormProvider {...formHandler}>
        <form>{formSteps[currentStep - 1]}</form>
      </FormProvider>
    ) : (
      formSteps[currentStep - 1]
    );

  return content;
};

export default SignUp;
